export const Eye = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_2827_4856)'>
      <path
        d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z'
        fill='#94A3B8'
      />
      <path
        d='M14.58 7.66667C14.1533 6.92667 11.8067 3.21333 7.82 3.33333C4.13333 3.42667 2 6.66667 1.42 7.66667C1.36149 7.76801 1.33068 7.88298 1.33068 8C1.33068 8.11702 1.36149 8.23199 1.42 8.33333C1.84 9.06 4.08666 12.6667 8.01333 12.6667H8.18C11.8667 12.5733 14.0067 9.33333 14.58 8.33333C14.6385 8.23199 14.6693 8.11702 14.6693 8C14.6693 7.88298 14.6385 7.76801 14.58 7.66667ZM8 10.3333C7.53851 10.3333 7.08738 10.1965 6.70367 9.9401C6.31995 9.68371 6.02088 9.31929 5.84428 8.89293C5.66767 8.46657 5.62147 7.99741 5.7115 7.54479C5.80153 7.09217 6.02376 6.67641 6.35008 6.35009C6.6764 6.02376 7.09216 5.80153 7.54479 5.7115C7.99741 5.62147 8.46656 5.66768 8.89293 5.84428C9.31929 6.02089 9.6837 6.31996 9.94009 6.70367C10.1965 7.08738 10.3333 7.53851 10.3333 8C10.3333 8.61884 10.0875 9.21233 9.64991 9.64992C9.21233 10.0875 8.61884 10.3333 8 10.3333Z'
        fill='#94A3B8'
      />
    </g>
    <defs>
      <clipPath id='clip0_2827_4856'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const EyeOff = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_2827_4893)'>
      <path
        d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z'
        fill='#94A3B8'
      />
      <path
        d='M10.1933 12.08L9.33334 11.1867L9.28667 11.14L8.44001 10.2933C8.30565 10.3169 8.16971 10.3302 8.03334 10.3333C7.72413 10.3378 7.41712 10.2807 7.13017 10.1654C6.84322 10.0501 6.58204 9.87892 6.36183 9.66181C6.14162 9.4447 5.96676 9.18598 5.84742 8.90069C5.72808 8.61541 5.66664 8.30924 5.66667 8C5.66976 7.86363 5.68314 7.72769 5.70667 7.59333L4.37334 6.26L3.33334 5.24667C2.58089 5.95565 1.93628 6.77096 1.42 7.66667C1.36149 7.76801 1.33069 7.88298 1.33069 8C1.33069 8.11702 1.36149 8.23199 1.42 8.33333C1.84 9.06 4.08667 12.6667 8.01334 12.6667H8.18001C8.91837 12.6448 9.64718 12.4936 10.3333 12.22L10.1933 12.08Z'
        fill='#94A3B8'
      />
      <path
        d='M5.72666 3.84L7.59332 5.70667C7.72768 5.68313 7.86362 5.66976 7.99999 5.66667C8.61883 5.66667 9.21232 5.9125 9.64991 6.35009C10.0875 6.78767 10.3333 7.38116 10.3333 8C10.3302 8.13637 10.3169 8.27231 10.2933 8.40667L12.08 10.1933L12.64 10.7533C13.4019 10.0462 14.0556 9.23081 14.58 8.33333C14.6385 8.23199 14.6693 8.11703 14.6693 8C14.6693 7.88298 14.6385 7.76801 14.58 7.66667C14.1533 6.92667 11.8067 3.21333 7.81999 3.33333C7.08162 3.35524 6.35282 3.50641 5.66666 3.78L5.72666 3.84Z'
        fill='#94A3B8'
      />
      <path
        d='M13.8067 12.86L12.94 12L11.6067 10.6667L5.26001 4.31333L4.28001 3.33333L3.14001 2.19333C3.07785 2.13117 3.00406 2.08187 2.92284 2.04823C2.84163 2.01459 2.75458 1.99727 2.66668 1.99727C2.57877 1.99727 2.49173 2.01459 2.41051 2.04823C2.3293 2.08187 2.2555 2.13117 2.19335 2.19333C2.06781 2.31887 1.99728 2.48913 1.99728 2.66667C1.99728 2.8442 2.06781 3.01446 2.19335 3.14L3.68668 4.66667L4.85335 5.8L9.72668 10.6667L9.77334 10.7133L10.6667 11.6067L11.06 12L12.86 13.8067C12.922 13.8692 12.9957 13.9187 13.077 13.9526C13.1582 13.9864 13.2453 14.0039 13.3333 14.0039C13.4214 14.0039 13.5085 13.9864 13.5897 13.9526C13.671 13.9187 13.7447 13.8692 13.8067 13.8067C13.8692 13.7447 13.9188 13.671 13.9526 13.5897C13.9865 13.5085 14.0039 13.4213 14.0039 13.3333C14.0039 13.2453 13.9865 13.1582 13.9526 13.0769C13.9188 12.9957 13.8692 12.922 13.8067 12.86Z'
        fill='#94A3B8'
      />
    </g>
    <defs>
      <clipPath id='clip0_2827_4893'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
